export * from './tabs.module';
export * from './tabs';
export * from './tab-label.directive';
